import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoFormularioPECATA = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoFormularioPECATA = () => {
  const [loadingGetInfoFormularioPECATA, setLoadingGetInfoFormularioPECATA] = useState(false);
  const [successGetInfoFormularioPECATA, setSuccessGetInfoFormularioPECATA] = useState(false);
  const [errorGetInfoFormularioPECATA, setErrorGetInfoFormularioPECATA] = useState<any>(null);
  const [dataGetInfoFormularioPECATA, setDataGetInfoFormularioPECATA] = useState<any>(null);

  const [statusGetInfoFormularioPECATA, setStatusGetInfoFormularioPECATA] =
    useState<StatusGetInfoFormularioPECATA>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoFormularioPECATA = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoFormularioPECATA(true);
    setSuccessGetInfoFormularioPECATA(false);
    setErrorGetInfoFormularioPECATA(null);

    try {
      const res = await apiRecord.getInfoSolicitudPecata(userId);

      setStatusGetInfoFormularioPECATA({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoFormularioPECATA(true);
      setDataGetInfoFormularioPECATA(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoFormularioPECATA({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoFormularioPECATA(err);
      console.error("Error en getInfoFormularioPECATA:", err);

      throw err;

    } finally {
      setLoadingGetInfoFormularioPECATA(false);
    }
  };

  return {
    getInfoFormularioPECATA,
    loadingGetInfoFormularioPECATA,
    successGetInfoFormularioPECATA,
    errorGetInfoFormularioPECATA,
    dataGetInfoFormularioPECATA,
    statusGetInfoFormularioPECATA
  };
};

export default useGetInfoFormularioPECATA;
